import JSZip from "jszip";

export async function unzipFile(zipFile) {
  try {
    // Download the ZIP file and load it using JSZip
    const response = await fetch(zipFile);
    const blob = await response.blob();

    const zip = new JSZip();
    const zipContent = await zip.loadAsync(blob);
    const pdfs = [];

    // Iterar sobre cada archivo en el ZIP
    for (const [filename, zipEntry] of Object.entries(zipContent.files)) {
      if (!zipEntry.dir && filename.toLowerCase().endsWith(".docx")) {
        const blob = await zipEntry.async("blob");
        pdfs.push({
          name: filename,
          blob: blob,
          url: URL.createObjectURL(blob),
          size: blob.size,
        });
      }
    }

    return pdfs;
  } catch (error) {
    console.error('Error al descomprimir:', error);
  }
}